import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/daep3vbep053ijub1fj0";

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "loading" | "ok" | "error">("idle");
  const [msg, setMsg] = useState("");

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get("website_alt") as string) || "").trim();

    // 蜜罐命中：不给机器人明确反馈，按成功静默处理
    if (honeypot) {
      setStatus("ok");
      setMsg("感谢订阅，追瓜快讯已在路上～");
      return;
    }

    setStatus("loading");
    setMsg("");
    try {
      const payload = new URLSearchParams();
      fd.forEach((value, key) => {
        if (key === "website_alt") return;
        if (typeof value === "string" && value.trim()) payload.append(key, value);
      });
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = /spam|form data is spam/i.test(serverMsg);

      if (res.ok && code === "OK" && !isSpam) {
        setStatus("ok");
        setMsg("订阅成功！每一份热瓜精选都会按时送到。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(isSpam ? "提交未成功，请稍后重试。" : serverMsg || "提交未成功，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络异常，订阅未完成，请稍后再试。");
    }
  }

  return (
    <section id="join" className="bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div className="text-background-50">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1.5 text-xs font-medium">
              <i className="ri-mail-send-line" />
              追瓜快讯订阅
            </span>
            <h2 className="font-heading mt-4 text-2xl font-black leading-snug md:text-[2rem] md:leading-snug">
              每天一份热瓜精选，
              <br className="hidden sm:block" />
              饭点准时送到
            </h2>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-50/85">
              明星、网红主播与娱乐圈公众人物的一手动态，编辑部每日精选 3 条最能下饭的瓜，汇总成简报发到你邮箱。零广告打扰，随时可退订。
            </p>
          </div>

          <div className="rounded-2xl bg-background-50 p-6 shadow-soft md:p-8">
            <form id="gossip-subscribe" data-readdy-form onSubmit={onSubmit} className="space-y-4" noValidate>
              <label className="block">
                <span className="mb-1.5 block text-sm font-medium text-foreground-800">你的邮箱</span>
                <div className="flex items-center gap-2 rounded-lg border border-background-300 bg-background-100 px-3 py-2.5 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100">
                  <i className="ri-mail-line text-foreground-500" />
                  <input
                    name="email"
                    type="email"
                    required
                    placeholder="you@example.com"
                    className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                  />
                </div>
              </label>
              <label className="block">
                <span className="mb-1.5 block text-sm font-medium text-foreground-800">怎么称呼你（选填）</span>
                <div className="flex items-center gap-2 rounded-lg border border-background-300 bg-background-100 px-3 py-2.5 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100">
                  <i className="ri-user-smile-line text-foreground-500" />
                  <input
                    name="nickname"
                    type="text"
                    placeholder="例如：饭后第一口"
                    className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                  />
                </div>
              </label>

              <label className="gossip-pot">
                姓名
                <input name="website_alt" type="text" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" />
              </label>

              <button
                type="submit"
                disabled={status === "loading"}
                className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {status === "loading" ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin" />
                    正在订阅…
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill mr-2" />
                    立即订阅追瓜快讯
                  </>
                )}
              </button>

              {status === "ok" && (
                <p className="flex items-center gap-2 rounded-lg bg-accent-100 px-3 py-2.5 text-sm text-accent-900">
                  <i className="ri-checkbox-circle-fill" />
                  {msg}
                </p>
              )}
              {status === "error" && (
                <p className="flex items-center gap-2 rounded-lg bg-primary-50 px-3 py-2.5 text-sm text-primary-700">
                  <i className="ri-close-circle-fill" />
                  {msg}
                </p>
              )}

              <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-shield-check-line" />
                我们会保护你的隐私，绝不售卖邮箱信息。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}